import { useState } from 'react';

export function NotifyMessage({
  showMode = false,
  notifyKey,
  notifyDelay = 5 * 60 * 1000,
  arrowPosition = 'right',
  className = '',
  onClose,
  children,
}) {
  const [isShowNotifyGiftMessage, setIsShowNotifyGiftMessage] = useState(() => {
    if (showMode) return true;
    const lastClose = localStorage.getItem(notifyKey);
    if (!lastClose) return true;
    return Date.now() - parseInt(lastClose, 10) > notifyDelay;
  });

  const handleCloseNotifyMessage = () => {
    setIsShowNotifyGiftMessage(false);
    onClose?.();
    if (showMode) return;
    localStorage.setItem(notifyKey, Date.now().toString());
  };

  if (!isShowNotifyGiftMessage) return null;

  return (
    <div
      className={`absolute z-[70] right-0 bottom-full mb-7 flex items-start gap-1 border border-white bg-black/40 backdrop-blur-[2px] rounded-2xl px-3 py-[6px] text-white text-[13px] font-semibold ${className}`}
    >
      {children}
      <button
        className="shrink-0 p-2 rounded-full bg-white/10"
        onClick={(e) => {
          e.stopPropagation();
          handleCloseNotifyMessage();
          console.log('asdasd');
          
        }}
      >
        <img className="size-2" src="/icons/close.svg" alt="close" />
      </button>
      {arrowPosition === 'right' && (
        <div className="absolute right-4 top-[calc(100%-7.5px)] w-4 h-4 rotate-45 border-r border-b border-white bg-black/40 backdrop-blur-[2px] [clip-path:polygon(0_100%,100%_100%,100%_0)]" />
      )}
      {arrowPosition === 'left' && (
        <div className="absolute left-4 top-[calc(100%-7.5px)] w-4 h-4 rotate-45 border-r border-b border-white bg-black/40 backdrop-blur-[2px] [clip-path:polygon(0_100%,100%_100%,100%_0)]" />
      )}
    </div>
  );
}
